import { useCallback, useState } from "react";

interface UseToggleAccordionProps {
  hasExpandableContent: boolean;
  onExpandAccordionItem?: () => void;
}

const useToggleAccordion = ({
  hasExpandableContent,
  onExpandAccordionItem,
}: UseToggleAccordionProps) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const toggleIsAccordionOpen = useCallback(() => {
    if (hasExpandableContent) {
      setIsAccordionOpen((prevState) => {
        if (!prevState) {
          onExpandAccordionItem?.();
        }
        return !prevState;
      });
    }
  }, [onExpandAccordionItem, hasExpandableContent]);

  return { isAccordionOpen, toggleIsAccordionOpen };
};

export default useToggleAccordion;
